<template>
  <div class="content-box">
    <HconMyPageUsrInfo />

    <div class="sub-wrapper">
      <HconMyPageSideMenu />
      <div class="sub-contents">
        <div class="border-title title">
          <p class="title">H캐시 관리<span class="desc">H캐시 이용내역 조회 및 충전을 하실 수 있습니다.</span></p>
          <div class="button-box">
            <div class="col2 row">
              <button type="button" @click="extinctionMoneypop" class="text-gray02 link-underline">소멸예정 H캐시 <strong class="font-bold">{{ extiontionDueHcash.toLocaleString() }}</strong>원 (30일 이내)</button>
              <NuxtLink to="/pc/mypage/hcash/charge" class="btn shrink0"><img src="@/assets/images/pc/icon-hcon/icon-plus-white.svg" class="btn-icon mr4" alt="" />H캐시 충전하기</NuxtLink>
              <button type="button" v-if="commonInfo?.userHcashDto?.availableHcash && commonInfo?.userHcashDto?.availableHcash > 0" @click="refundAccountCheck()" class="btn btn-gray shrink0"><img src="@/assets/images/pc/icon-hcon/icon-refund-white.svg" class="btn-icon mr6" alt="" />환불신청</button>
            </div>
          </div>
        </div>
        <div class="box-gray mt28 search">
          <fieldset class="search-form-wrap">
            <legend>H캐시 관리 검색 폼</legend>
            <div class="search-form">
              <div class="form-box">
                <div class="form-group row">
                  <HconMonthDate label="조회기간" v-model="qryDates"/>
                </div>
              </div>
              <div class="form-box">
                <div class="form-group row">
                  <HconDropDown type="dropdownBox" v-model="inputValues.qryPntTrdTypDivCd" :dropdown-options="dropDownPntTrdTypCd" label="거래유형" :hide-label="false" defaultLabel="거래유형" selectBoxTitleClass="w300" />
                  <HconInput type="text"  v-model="inputValues.qrySrchValue" label="검색어" labelClass="ml20" placeholder="거래번호/거래명을 입력해주세요." />
                </div>
              </div>
            </div>
            <div class="btn-box">
              <button type="button" class="btn lg" @click="clickSearchButton">조회</button>
            </div>
          </fieldset>
        </div>
        <div class="contents-title-wrap mt40 button">
          <div class="contents-title">
            <h4 class="font-bold">총 <span class="text-green"> {{ totalData }} </span>건</h4>
          </div>
          <div class="rgt-area">
            <HconComPCExcelExport api="/api/v1/mypage/hcash/list/excel" :query="searchParams">
              <button type="button" class="btn btn-outline" :disabled="cu.isEmpty(hcashList)">엑셀다운로드</button>
            </HconComPCExcelExport>            
          <HconDropDown type="dropdownBox" :dropdownOptions="dropDownRowPerPage" selectBoxTitleClass="counter ml8" v-model="stringRowPerPage" />
          </div>

        </div>
        <div class="contents-detail-wrap">
          <table class="tbl-type">
            <caption>최근 H캐시 사용 및 충전 내역</caption>
            <colgroup>
              <col style="width: 15%;"/>
              <col style="width: 10%;"/>
              <col style="width: auto;"/>
              <col style="width: 15%;"/>
              <col style="width: 15%;"/>
              <col style="width: 13%;"/>
            </colgroup>
            <thead>
              <tr>
                <th scope="col">거래일시/유효기간</th>
                <th scope="col">거래유형</th>
                <th scope="col">거래명/비고</th>
                <th scope="col" class="right pr10">H캐시</th>
                <th scope="col">결제수단</th>
                <th scope="col">증빙서류</th>
              </tr>
            </thead>
            <tbody v-if="hcashList.length > 0">
              <tr v-for="(hcash, index) in hcashList" :key="index">
                <td class="order-number"><span>{{ HconCommonUtils.format.dateTimeNoSec(hcash.pntDtm) }} </span><br/>
                  <span v-if="hcash.pntExtnDueDt && hcash.cancelFlag < 1">유효기간: {{HconCommonUtils.format.date(hcash.pntExtnDueDt)}}</span>
                </td>
                <td>{{ hcash.hcPntTrdTypCdNm }}</td>
                <td class="left">
                  <p class="title01">{{ hcash.pntTrdCntn }}</p>
                  <p class="desc01" v-if="hcash.pntApvNo && !hcash.ordNo && hcash.hcPntTrdTypCd != '1005'">거래번호 : {{ hcash.pntApvNo }} <span v-if="hcash.orglPntAcmApvNo !== null && hcash.orglPntAcmApvNo !== ''">/ 원거래번호 : {{ hcash.orglPntAcmApvNo }}</span> </p>
                  <p class="desc01" v-if="hcash.ordNo"><NuxtLink :to="getOrderDetailPath(hcash)" class="link-underline text-gray02">주문번호 : {{ hcash.ordNo }}</NuxtLink></p>
                  <div class="desc01" v-if="hcash.hcEncActno != '' && (hcash.hcPntTrdTypCd == '10054' || hcash.hcPntTrdTypCd == '10051')">
                    <p class="mt2">
                      {{ (hcash.hcPntTrdTypCd == '10054') ? '입금완료' : '입금 예정액' }}
                      <span :class="(hcash.hcPntTrdTypCd == '10054') ? 'text-red' : 'text-green'">{{ hcash.trdAmt.toLocaleString() }}</span>원 (환불수수료 5% 차감)
                    </p>
                  </div>
                </td>
                <td class="right">
                  <strong class="fs16 font-bold" :class=" (hcash.hcPntTrdTypCd == '10054') || (hcash.hcPntTrdTypCd == '1003' && hcash.hcPntTrdDivCd == '1001')  || ( hcash.hcPntTrdTypCd == '1001' && hcash.hcPntTrdDivCd == '1002') ? 'text-red' : 'text-green'">
                    <span v-if="(hcash.hcPntTrdTypCd == '10054') || (hcash.hcPntTrdTypCd == '1003' && hcash.hcPntTrdDivCd == '1001') ">-</span>{{ (hcash.hcPntTrdTypCd == '10051') ? 0 : hcash.trdAmt.toLocaleString() }}원
                  </strong>
                </td>
                <td>{{ hcash.hcPymtMnsCdNm}}
                  <div class="tbl-btn-box" v-if="hcash.hcPntTrdTypCd == '1001' && hcash.hcPntTrdDivCd== '1001' && hcash.cancelFlag < 1">
                    <button type="button" v-if="HconCommonUtils.format.dateDiff(hcash.pntDtm.substring(0,8), HconCommonUtils.format.nowDtm().substring(0,8)) < 8" @click="hmoneyChargeCancelConfirm(hcash.hcPymtUsgCd, hcash.pntApvNo)" class="btn btn-outline xs">충전취소</button>
                  </div>
                </td>
                <td>
                  <div class="tbl-btn-box" v-if="hcash.hcPymtMnsCd === '1001' || hcash.hcPymtMnsCd === '1002'">
                    <button type="button" class="btn btn-outline xs" @click="showCardReceipt(hcash.pgApvNo)">거래영수증</button>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="6" class="nodata">H캐시 내역이 없습니다.</td>
              </tr>
            </tbody>
          </table>
          <HconPagination v-if="hcashList.length > 0" :max-page="totalPage" :current-page="currentPage" @update:currentPage="handlePagination" />
        </div>
      </div>
    </div> 
      <RefundPopup v-if="isRefundPopup" @success="handleRefundPopupResult" @cancel="handleRefundPopupResult"/>
      <ExtintionHcashPopup :extAmt="extiontionDueHcash"  @success="handleExtintionHcashPopupResult" @cancel="handleExtintionHcashPopupResult" v-if="isExtintionHcashPopup"/>
  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router';
import HconInput from '@/components/com/HconComPCInputField.vue'
import HconDropDown from '@/components/com/HconComPCDropDown.vue'
import HconPagination from '@/components/com/HconComPCPagination.vue'
import HconMonthDate from '@/components/com/HconComPCDateButton.vue'
import { HconCommonUtils } from '@/utils/hcon-common-utils'
import { usePopup } from '@/composables/hconUsePopup'
import HconComPCExcelExport from "@/components/com/HconComPCExcelExport.vue";
import HconMyPageSideMenu from '@/components/corner/pc/HconCornerMypageSideMenuPC.vue';
import HconMyPageUsrInfo from '@/components/corner/pc/HconCornerUserInfoPC.vue';
import RefundPopup from '@/pages/pc/mypage/hcash/refundPopup.vue'
import ExtintionHcashPopup from '~/pages/pc/mypage/hcash/extintionHcashPopup.vue'
// 마이 Hcon 정보
import imgGradeB from '@/assets/images/pc/icon-hcon/grade-B.png'
// DTO 준비
import type { HcashInfoDto } from '~/types/hcash/backend-dto-types'
import type {UserCommonInfoDto } from '~/types/mypage/backend-dto-types';
import { MEMBER_CODE, ORDER_CODE } from '~/constants/hconMessageConstants';
// 팝업 준비
const { showAlert, showConfirm } = usePopup()
const fetchBuilder        = useHconFetchBuilder();
// lnb
const route = useRoute()
definePageMeta({
      "require-auth" : true
  });

const { refreshCnt, commonInfo } = useHeader();
const hcPntTrdTypCdList            = reactive<any[]>([])
const qryDates = ref<[Date, Date] | null>(null);
const isRefundPopup = ref(false)
const isExtintionHcashPopup = ref(false)
const extiontionDueHcash = ref(0)

const setUserCommInfo = (data : UserCommonInfoDto) => {
  commonInfo.value = data
}

onMounted(async () => {
  getTotalExtintionDueHcash();
  getHcashList();
})

const inputValues = ref({
    userKey: '' 
  , pageNum: ''
  , pageSize: '' 
  , qryStrtDt: '' 
  , qryEndDt: '' 
  , qrySrchValue: ''
  , qryPntTrdTypDivCd: ''
  , qryPntTrdTypCd: ''
  , qryPntTrdDivCd: ''
});

// 조회조건 읽기전용 매핑대상 준비
const searchParams = computed(() => {
  const qryStartDate = qryDates.value? HconCommonUtils.format.date(qryDates.value[0],'YYYYMMDD') : '';
  const qryEndDate = qryDates.value? HconCommonUtils.format.date(qryDates.value[1],'YYYYMMDD') : '';
  const qryPntTrdTypDivCd = inputValues.value.qryPntTrdTypDivCd;
  const qryPntTrdTypCd = ref('');
  const qryPntTrdDivCd = ref('');
  const qryHcRfndStCd = ref('');

  if(qryPntTrdTypDivCd == '10011') {
    qryPntTrdTypCd.value = '1001'
    qryPntTrdDivCd.value = '1001'
  } else if (qryPntTrdTypDivCd == '10012') {
    qryPntTrdTypCd.value = '1001'
    qryPntTrdDivCd.value = '1002'
  } else if (qryPntTrdTypDivCd == '10031') {
    qryPntTrdTypCd.value = '1003'
    qryPntTrdDivCd.value = '1001'
  } else if (qryPntTrdTypDivCd == '10032') {
    qryPntTrdTypCd.value = '1003'
    qryPntTrdDivCd.value = '1002'
  } else if (qryPntTrdTypDivCd == '10070') {
    qryPntTrdTypCd.value = '1007'
  } else if (qryPntTrdTypDivCd == '10051') {
    qryPntTrdTypCd.value = '10051'
    // qryHcRfndStCd.value = '1001'
    qryPntTrdDivCd.value = '1001'
  } else if (qryPntTrdTypDivCd == '10054') {
    qryPntTrdTypCd.value = '10054'
    // qryHcRfndStCd.value = '1004'
    qryPntTrdDivCd.value = '1001'
  }

  return {
    ...inputValues.value
    , qryStrtDt: qryStartDate // 조회시작일자
    , qryEndDt: qryEndDate // 조회종료일자
    , pageNum: currentPage.value
    , pageSize: rowPerPage.value
    , qryPntTrdTypCd: qryPntTrdTypCd.value
    , qryPntTrdDivCd: qryPntTrdDivCd.value
    , qryHcRfndStCd:  qryHcRfndStCd.value
    , qrySrchValue: inputValues.value.qrySrchValue
  }
})

// 마이페이지 주문내역 목록 매핑대상 준비
const hcashList = ref<HcashInfoDto[]>([]);
//////////////////////////////////////////////
//       목록조회 시 페이징 처리 관련 모음
//////////////////////////////////////////////
/**
 * 1. 아래의 변수 4종과 함수 2종 선언
 * 2. 페이지네이션 컴포넌트는 HconComPCPagination.vue 사용
 * 3. API호출 시 아래 2종 반영
      3.1. .query 부분, pageNum & pageSize도 쿼리스트링에 포함 필요
      3.2. .then 부분, 총건수 세팅 필요
                       ex) ((result) => {
                             totalData.value = result.total || 0;
                           })
 * 4. 서비스(hcon-fo-api)에서는 아래 2종 반영
      4.1. requestDto에 int pageNum; & int pageSize; 추가
      4.2. controller에서 startPage(); 추가
 **/
// 1. 페이지네이션 매핑대상 변수 준비
const currentPage = ref<number>(1);  // 페이징 번호
const rowPerPage  = ref<number>(20); // 페이징 건수
const totalData   = ref<number>(0);  // 총 데이터 건수
const totalPage = computed (() => {  // 총 페이지 건수(계산식)
  if(hcashList.value.length === 0) return 0;
  return Math.ceil(totalData.value / rowPerPage.value);
});

// 2. 페이지네이션 클릭이벤트 핸들링 함수
const handlePagination = (pageNum: number) => {
  // 2.1. 숫자 클릭 시, 현재페이지를 새값으로 바꾸고 API호출
  currentPage.value = pageNum; 
  getHcashList();
}

// 추가기능1: 건수변경 드롭다운이 있을 경우, v-model 연결 및 API 즉시호출
const stringRowPerPage = computed({
  get: () => String(rowPerPage.value),
  set: (newVal: string) => {
    rowPerPage.value = Number(newVal);
    if(typeof currentPage !== 'undefined') {
      currentPage.value = 1;
    }
    getHcashList();
  }
})

// 추가기능2: 조회조건에 따른 (재)조회버튼이 있을 경우, 1페이지로 재설정 필요
const clickSearchButton = () => {
  currentPage.value = 1;
  getHcashList();
}

const dropDownRowPerPage = [ // 페이징건수
    {key: '20', value: '20개씩 보기'}
  , {key: '40', value: '40개씩 보기'}
  , {key: '100', value: '100개씩 보기'}
];

const dropDownPntTrdTypCd = [ // 주문상태
    {key: '', value: '전체'}
  , {key: '10011', value: '충전'}
  , {key: '10012', value: '충전취소'}
  , {key: '10031', value: '사용'}
  // , {key: '10032', value: '사용취소'}
  , {key: '10070', value: '환급'}
  , {key: '10051', value: '환불신청'}
  , {key: '10054', value: '환불완료'}
];


const refundAccountCheck = async () => {
  fetchBuilder.get<TableDataInfo<HcashInfoDto>>('/api/v1/mypage/hcash/check-refund-account')
      .query()
      .build().execute()
      .then(async (result) => {
            if(!result.data) {
              const result = await showConfirm({
                title: "환불계좌 등록 및 승인 요청",
                message: HconCommonUtils.format.message(ORDER_CODE.ALT_HCON_9040)
              })

              if (result) {
                useRouter().push("/pc/mypage/account");
              }

            } else {
              isRefundPopup.value = true
            } 
            // popupCode.value = code
            // isRefundPopup.value = true
          
          });

}

const hmoneyChargeCancelConfirm = async (hcPymtUsgCd:string, rfrNo:string) => {
  const result = await showConfirm({
    title: "H캐시 충전 취소",
    message: HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9050)
  })

  if(result){
    await fetchBuilder.post<AjaxResult<any>>('/api/v1/mypage/hcash/charge/cancel')
      .body({
        hcPymtUsgCd: hcPymtUsgCd,
        rfrNo: rfrNo
      })
      .progressMessage("잠시만 기다려주세요...")
      .preventErrorNotify()
      .build()
      .execute()
      .then((result2) => {
        if(result2){
          showAlert({
            title: "H캐시 충전 취소 완료",
            message: HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9051)
          })
          refreshCnt();
        }
      }) 
      .catch((error) => {    // 응답코드가 200이 아닌경우
        if(error.resultCode != '200') {
          if(error.resultCode == '29209') {
            showAlert({
              title: '충천 취소 오류',
              message: error.resultMessage /*이전에 사용한 비밀번호는 다시 사용할 수 없습니다.*/
            })
          }
          else {
            showAlert(error.resultMessage)
          }
        }
      })
  }
}

const extinctionMoneypop = async () => {
isExtintionHcashPopup.value = true;
}
const getTotalExtintionDueHcash = () => {
  fetchBuilder.get<AjaxResult<number>>('/api/v1/mypage/hcash/get-total-extintion-due-hcash')
      .query()
      .build().execute()
  .then((result) => {
    extiontionDueHcash.value = result.data
    });
}
const getHcashList = () => {
fetchBuilder.get<TableDataInfo<HcashInfoDto>>('/api/v1/mypage/hcash/list')
      .query(searchParams.value)
      .build().execute()
  .then((result) => {
          // ref 형식 변수에 값 즉시 세팅
          hcashList.value = result.data || [];
          // 페이지네이션 처리
          totalData.value = result.total || 0;
    });
}

const handleRefundPopupResult = (payload:string) => {

  if(payload == "f"){
    isRefundPopup.value = false;
    document.body.style.overflow=''
  } else if (payload == "s"){
    isRefundPopup.value = false;
    document.body.style.overflow=''
    window.location.reload();
  } else {
    isRefundPopup.value = false;
    document.body.style.overflow=''
  }
}

const handleExtintionHcashPopupResult = (payload:string) => {
  if(payload == "f"){
    isExtintionHcashPopup.value = false;
    document.body.style.overflow=''
  } else if (payload == "s"){
    isExtintionHcashPopup.value = false;
    document.body.style.overflow=''
  } else {
    isExtintionHcashPopup.value = false;
    document.body.style.overflow=''
  }
}

import { usePayment, type ReceiptParams } from '@/composables/usePayment';
const { openInicisReceipt } = usePayment()

const showCardReceipt = async(pgApvNo : string) => {

    var params: ReceiptParams = {
        "tid": pgApvNo
      , "noTid": pgApvNo
      , "subMerchantoid": ""
      , "rt": "-1"
      , "reMail": 'null'
    }
    
    openInicisReceipt(params)
}

const getOrderDetailPath = (hcash: HcashInfoDto) => {
  if(hcash.hcOrdTypCd === '1002') { 
    return `/pc/mypage/order/pin-detail/${hcash.ordNo}`;
  } else {
    return `/pc/mypage/order/detail/${hcash.ordNo}`;
  }
}
</script>
<style lang="scss" scoped>
@use "@/assets/scss/pc/order-hcon.scss" as *;
@use "@/assets/scss/pc/mypage-hcon.scss" as *;

</style>